export default __webpack_public_path__ + "static/media/cloud-download.1503cf1c.svg";